import { useRef } from "react";

import {
  BoardTransitionPlayer,
  type AnimationFeedback,
} from "../../animation/BoardTransitionPlayer";
import type { ActiveAnimation } from "../../animation/animationChannel";
import type { Player } from "../../game";
import type { MotionPreference } from "../../platform/settings/settingsStore";
import { GameBoard, type GameBoardProps } from "../GameBoard/GameBoard";

export type MatchBoardSurfaceProps = GameBoardProps &
  Readonly<{
    activeAnimation: ActiveAnimation | null;
    animationFeedback?: AnimationFeedback | undefined;
    className?: string | undefined;
    motion: MotionPreference;
    onAnimationFinish: (id: number) => void;
    viewFrom: Player;
  }>;

export function MatchBoardSurface({
  activeAnimation,
  animationFeedback,
  className,
  motion,
  onAnimationFinish,
  viewFrom,
  ...boardProps
}: MatchBoardSurfaceProps) {
  const boardRoot = useRef<HTMLDivElement>(null);

  return (
    <div className={["match-board-wrap", className].filter(Boolean).join(" ")} ref={boardRoot}>
      <GameBoard {...boardProps} viewFrom={viewFrom} />
      <BoardTransitionPlayer
        active={activeAnimation}
        boardRoot={boardRoot}
        {...(animationFeedback === undefined ? {} : { feedback: animationFeedback })}
        motion={motion}
        onFinish={onAnimationFinish}
        viewFrom={viewFrom}
      />
    </div>
  );
}
